module.exports = __webpack_public_path__ + "7ef8000adcc548d1a25eb063f146b01a.svg";